import React, { useState, useRef } from 'react'
import { useDebounce, usePrevious, useUpdateEffect } from 'react-use'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface SearchInputProps {
    placeholder: string
    className?: string
    initialValue?: string | undefined
    onSearchChange(query: string): void
}

const SearchInput: React.FunctionComponent<SearchInputProps> = ({
    placeholder,
    className,
    initialValue,
    onSearchChange
}: SearchInputProps) => {
    const [val, setVal] = useState(initialValue || '')
    const previousVal = usePrevious(val)
    const inputRef = useRef<HTMLInputElement>(null)

    const [, cancel] = useDebounce(
        () => {
            if (val !== previousVal) {
                onSearchChange(val)
            }
        },
        500,
        [val]
    )

    useUpdateEffect(() => {
        if (initialValue) {
            setVal(initialValue)
        } else {
            setVal('')
        }
    }, [initialValue])

    const handleKeyDown = (e: any) => {
        if (e.keyCode === 27) {
            e.preventDefault()
            setVal('')
            inputRef.current && inputRef.current.blur()
        }
    }

    return (
        <div className={`border rounded flex justify-between items-center bg-white ${className}`}>
            <input
                type='search'
                name='search'
                className='w-full rounded border-none'
                ref={inputRef}
                placeholder={placeholder}
                value={val}
                onKeyDown={handleKeyDown}
                onBlur={cancel}
                onChange={({ currentTarget }) => {
                    setVal(currentTarget.value)
                }}
            />
            <DynamicFaIcon iconName='search' className='text-gray-400 px-2' />
        </div>
    )
}

export default SearchInput
